import {
  IPayoutOptionDTO,
  PayoutAccountTypeEnum,
  PayoutAccountTypeTypes,
  PayoutMethodIdEnum,
  PayoutRequestStatusEnum,
  PayoutRequestStatusTypes,
} from "@hooks/dtos/IPayoutDTO";

export const payoutRequestStatuses: IPayoutOptionDTO<PayoutRequestStatusTypes>[] =
  [
    {
      type: PayoutRequestStatusEnum.WAITING,
      text: "Aguardando",
      title: "Solicitação aguardando análise ou processamento.",
      color: "warning",
    },
    {
      type: PayoutRequestStatusEnum.SENT,
      text: "Enviado",
      title: "Saque enviado para processamento.",
      color: "info",
    },
    {
      type: PayoutRequestStatusEnum.CANCELLED,
      text: "Cancelado",
      title: "Saque cancelado.",
      color: "secondary",
    },
    {
      type: PayoutRequestStatusEnum.PAID,
      text: "Pago",
      title: "Saque pago com sucesso.",
      color: "success",
    },
    {
      type: PayoutRequestStatusEnum.REJECTED,
      text: "Rejeitado",
      title: "Saque rejeitado ou excluído.",
      color: "danger",
    },
  ];

export const payoutAccountTypes: IPayoutOptionDTO<PayoutAccountTypeTypes>[] = [
  {
    type: PayoutAccountTypeEnum.PIX,
    text: "PIX",
    title: "Conta de saque via PIX.",
    color: "success",
  },
  {
    type: PayoutAccountTypeEnum.BANK,
    text: "Banco",
    title: "Conta bancária para saque.",
    color: "primary",
  },
  {
    type: PayoutAccountTypeEnum.WALLET,
    text: "Carteira",
    title: "Carteira digital para saque.",
    color: "info",
  },
  {
    type: PayoutAccountTypeEnum.OTHER,
    text: "Outro",
    title: "Outro tipo de destino de saque.",
    color: "secondary",
  },
];

export const payoutMethods: IPayoutOptionDTO<PayoutMethodIdEnum>[] = [
  {
    type: PayoutMethodIdEnum.PIX,
    text: "PIX",
    title: "Saque via PIX.",
    color: "success",
  },
];

export function getPayoutRequestStatus(
  status?: PayoutRequestStatusTypes,
): IPayoutOptionDTO<PayoutRequestStatusTypes> {
  return (
    payoutRequestStatuses.find((item) => item.type === status) || {
      type: PayoutRequestStatusEnum.REJECTED,
      text: "Não informado",
      title: "Status não informado.",
      color: "secondary",
    }
  );
}

export function getPayoutAccountType(
  type?: PayoutAccountTypeTypes,
): IPayoutOptionDTO<PayoutAccountTypeTypes> {
  return (
    payoutAccountTypes.find((item) => item.type === type) || {
      type: PayoutAccountTypeEnum.OTHER,
      text: "Não informado",
      title: "Tipo de conta não informado.",
      color: "secondary",
    }
  );
}

export function getPayoutMethod(
  method?: PayoutMethodIdEnum,
): IPayoutOptionDTO<PayoutMethodIdEnum> {
  return (
    payoutMethods.find((item) => item.type === method) || {
      type: PayoutMethodIdEnum.PIX,
      text: "Não informado",
      title: "Método de saque não informado.",
      color: "secondary",
    }
  );
}
